import React from 'react';
import accounting from 'accounting';
import moment from 'moment';

import {
    Table,
    Button,
    Card,
    Tag,
    Input,
    Icon
} from 'antd';

import {
    _postCreditNotePaginate
} from '../../services';

const CREDITED_TYPE = {
    'Not Credited': false,
    'Credited': true
}

class CreditNote extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            creditNotes: [],
            creditNotecount: 0,

            creditedFilter: [],
            cartRefNumber_search: '',

            limit: 20,
            page: 1
        }
    }


    render() {
        return (
            <Card  title="Credit Notes">
                {this.renderCreditNoteTable()}
            </Card>
        )
    }

    componentDidMount() {
        this.getCreditNote()
    }

    getCreditNote = () => {
        const { 
            page, limit,
            creditedFilter,
            cartRefNumber_search
        } = this.state

        _postCreditNotePaginate({ page, limit, creditedFilter, cartRefNumber_search })
        .then(_creditNotes => {
            this.setState({
                creditNotes: _creditNotes.data.creditNotes,
                creditNotecount: _creditNotes.data.count
            })
        })
    }

    renderCreditNoteTable = () => {
        const {creditNotes, creditNotecount, limit, page } = this.state

        console.log({creditNotes})

        const columns = [{
            title: 'Cart RefNumber',
            dataIndex: 'cartRefNumber',
            ...this.getColumnSearchProps('cartRefNumber'),
        },{
            title: 'Amount',
            dataIndex: 'amount',
            render: (amount) => accounting.formatMoney( amount, '$', 2)

        },{
            title: 'Date Created',
            dataIndex: 'dateCreated',
            render: (dateCreated) =>  moment(dateCreated).format('LL')
        },{
            title: 'Date Credited',
            dataIndex: 'dateCredited',
            render: (dateCredited) =>  dateCredited ? '-' : moment(dateCredited).format('LL')
        },{
            title: 'Credited',
            dataIndex: 'creditedToAccount',
            filters: Object.keys(CREDITED_TYPE).map(type => ({text: type, value: CREDITED_TYPE[type]})),
            filteredValue: this.state.creditedFilter,
            render: (creditedToAccount) => creditedToAccount ? <Tag color="#87d068">True</Tag> : <Tag color="#f50">False</Tag>
        },{
            title: 'Created By',
            dataIndex: 'createdByUserName',
        }
    ]
        return (
            <Table
                onChange={this.handleTableChange}
                dataSource={creditNotes}
                columns={columns}
                pagination={{
                    pageSize: limit,
                    current: page,
                    total: creditNotecount,
                    onChange: (nextPage) => {
                        this.setState({ page: nextPage })
                    }
                }}
            />
        )
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={this.state[`${dataIndex}_search`]}
                    onChange={(e => this.setState({[`${dataIndex}_search`]: e.target.value}))}
                    onPressEnter={() => this.handleSearch(confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(confirm, dataIndex)}
                        icon='search'
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
              </Button>
                    <Button onClick={() => this.handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
                        Reset
              </Button>
            </div>
        ),
        filterIcon: filtered => <Icon type='search' />,
        render: text => text
    });

    handleSearch = (confirm, dataIndex) => {
        confirm();
        // Page is set to 1 because if on handleSearch page==2 but results only has 1 page, cant see any results
        this.setState({
            page: 1
        }, this.getCreditNote)
        
    };

    handleReset = (clearFilters, dataIndex) => {
        clearFilters();
        this.setState({ 
            [`${dataIndex}_search`]: '' 
        },this.getCreditNote);
        
    };
    
    handleTableChange = (pagination, filters, sorter, extra) => {

        this.setState({
            current: pagination.current,
            creditedFilter: filters.creditedToAccount,
        }, this.getCreditNote)
    }
}

export default CreditNote


// WEBPACK FOOTER //
// ./src/components/credit-note/index.js